import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { enableProdMode } from '@angular/core';
import { installEntraNativeAuthTokenCapture } from './app/utils/entra-native-token-capture';
import { bootstrapFirebaseSocialRedirect } from './firebase-social-bootstrap';

/** Google OAuth and local dev use https://localhost:4200 — bounce http → https before boot. */
function ensureLocalHttps(): void {
  if (typeof window === 'undefined') {
    return;
  }
  const { hostname, protocol, host, pathname, search, hash } = window.location;
  if (
    (hostname === 'localhost' || hostname === '127.0.0.1') &&
    protocol === 'http:'
  ) {
    window.location.replace(`https://${host}${pathname}${search}${hash}`);
  }
}

ensureLocalHttps();

installEntraNativeAuthTokenCapture();

if (environment.production) {
  enableProdMode();
}

bootstrapFirebaseSocialRedirect()
  .catch((err) => console.error('[firebase] redirect bootstrap failed', err))
  .finally(() => {
    platformBrowserDynamic()
      .bootstrapModule(AppModule)
      .catch((err) => console.error(err));
  });
